// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold',
  {
    variants: {
      variant: {
        // Patient-domain variants (kept for backward compatibility)
        unopened:      'bg-amber-50 text-amber-700 border border-amber-200',
        completed:     'bg-accent text-accent-foreground',
        'in-progress': 'bg-primary text-primary-foreground',
        reviewed:      'bg-emerald-50 text-emerald-700 border border-emerald-200',
        default:       'bg-muted text-muted-foreground',
        // Operator-domain variants for OrgStatus
        active:        'bg-emerald-50 text-emerald-700 border border-emerald-200',
        suspended:     'bg-amber-50 text-amber-700 border border-amber-200',
        archived:      'bg-muted text-muted-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
